<template>
    <div class="flashable" :class="{ 'flashable active': isActive }">
        <slot></slot>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isActive: false,
        }
    },

    methods: {
        flash() {
            this.isActive = true;
            setTimeout(() => this.isActive = false, 400)
        }
    }
}
</script>

<style lang="scss" scoped>
.flashable {
    transition: 0.4s;

    &.active {
        background-color: red;
    }
}
</style>
